module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Meine Sortimentsauswahl","supplier":"Lieferantenname ","article_name":"Artiklename","model_name":"Modellname","van":"VAN","ean":"EAN","han":"HAN","price_binding":"Preisbindung"},"en":{"title":"My assortment selection","supplier":"Supplier name ","article_name":"Item name","model_name":"Model name","van":"VAN","ean":"EAN","han":"HAN","price_binding":"Price bond"}}')
  delete Component.options._Ctor
}
